import React from 'react';
import { LineLayer as BaseLayer } from './LineLayer';

const SymbolLayer = React.forwardRef(function SymbolLayer(props, ref) {
  return <BaseLayer type="symbol" ref={ref} {...props} />;
});

export { SymbolLayer };
